import { createSlice } from "@reduxjs/toolkit";

const readJson = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

const initialState = {
  adminProfile: readJson("dp_admin_profile", {
    id: null,
    name: "",
    email: "",
    role: "administrator",
    password: "",
    mustUpdateCredentials: false,
    lastLogin: null,
  }),
  adminSession: readJson("dp_admin_session", {
    isAuthenticated: false,
    token: null,
    role: null,
  }),
  clientSession: readJson("dp_client_session", {
    isAuthenticated: false,
    token: null,
    passcode: null,
    clientId: null,
    clientSlug: null,
    client: null,
  }),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    adminLoginSuccess(state, action) {
      state.adminSession = {
        isAuthenticated: true,
        token: action.payload.token,
        role: "administrator",
      };
      localStorage.setItem("dp_admin_session", JSON.stringify(state.adminSession));
    },
    adminLogout(state) {
      state.adminSession = {
        isAuthenticated: false,
        token: null,
        role: null,
      };
      state.adminProfile = {
        id: null,
        name: "",
        email: "",
        role: "administrator",
        password: "",
        mustUpdateCredentials: false,
        lastLogin: null,
      };
      localStorage.setItem("dp_admin_session", JSON.stringify(state.adminSession));
      localStorage.setItem("dp_admin_profile", JSON.stringify(state.adminProfile));
    },
    updateAdminProfile(state, action) {
      state.adminProfile = {
        ...state.adminProfile,
        ...action.payload,
      };
      localStorage.setItem("dp_admin_profile", JSON.stringify(state.adminProfile));
    },
    clientLoginSuccess(state, action) {
      state.clientSession = {
        isAuthenticated: true,
        token: action.payload.token,
        passcode: action.payload.passcode,
        clientId: action.payload.clientId,
        clientSlug: action.payload.clientSlug || null,
        client: action.payload.client || null,
      };
      localStorage.setItem("dp_client_session", JSON.stringify(state.clientSession));
    },
    clientLogout(state) {
      state.clientSession = {
        isAuthenticated: false,
        token: null,
        passcode: null,
        clientId: null,
        clientSlug: null,
        client: null,
      };
      localStorage.setItem("dp_client_session", JSON.stringify(state.clientSession));
    },
  },
});

export const {
  adminLoginSuccess,
  adminLogout,
  updateAdminProfile,
  clientLoginSuccess,
  clientLogout,
} = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectAdminProfile = (state) => state.auth.adminProfile;

export default authSlice.reducer;
